<div class="category-shell container">
  <h2>Category: {{ category }}</h2>
  <p>Entries filtered by category will appear here.</p>
</div>
